import React from 'react'
import FormField from '@/components/common/FormField'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { errorTypes } from '@/utility/validation'
import { useFormContext } from 'react-hook-form'
import type { OnboardTabProps } from './onboard.types'

const OnboardAdvanceDetails: React.FC<OnboardTabProps> = ({ isLoading, handleNextStep }) => {
    const methods = useFormContext()
    const { register, formState: { errors } } = methods

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
                <FormField
                    {...register("aadharNumber", { ...errorTypes.required('Aadhar Number'), ...errorTypes.aadhaar })}
                    label="Aadhar Number"
                    placeholder="Aadhar number"
                    type="text"
                    maxLength={12}
                    error={errors.aadharNumber?.message as string}
                    required
                />
                <FormField
                    {...register("panNumber", { ...errorTypes.required('Pan card number'), ...errorTypes.pan })}
                    label="PAN Number"
                    placeholder="Enter pan number"
                    type="text"
                    pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                    maxLength={10}
                    error={errors.panNumber?.message as string}
                    required
                />
                <FormField
                    {...register("uanNumber", { ...errorTypes.required('UAN Number'), ...errorTypes.uan })}
                    label="UAN Number"
                    placeholder="Enter 12-digit UAN number"
                    type="text"
                    maxLength={12}
                    error={errors.uanNumber?.message as string}
                    required
                />
                <FormField
                    {...register("esicNumber", { ...errorTypes.required('ESIC Number'), ...errorTypes.esic })}
                    label="ESIC Number"
                    placeholder="Enter ESIC number"
                    type="text"
                    maxLength={10}
                    error={errors.esicNumber?.message as string}
                    required
                />
                <FormField
                    {...register("pfNumber", { ...errorTypes.required('PF Number'), ...errorTypes.pfNumber })}
                    label="PF Number"
                    placeholder="Enter PF number (e.g. MH/BAN/0012345/000/0001234)"
                    type="text"
                    maxLength={22}
                    error={errors.pfNumber?.message as string}
                    required
                />
                <FormField
                    {...register("insuranceNumber", { ...errorTypes.required('Insurance Number'), ...errorTypes.insurance })}
                    label="Insurance Number"
                    placeholder="Enter insurance policy number"
                    type="text"
                    maxLength={25}
                    error={errors.insuranceNumber?.message as string}
                    required
                />
                <FormField
                    {...register("drivingLicenseNumber", { ...errorTypes.required('Driving License Number'), ...errorTypes.drivingLicense })}
                    label="Driving License Number"
                    placeholder="Enter Driving License (e.g. RJ1420180012345)"
                    type="text"
                    maxLength={16}
                    error={errors.drivingLicenseNumber?.message as string}
                    required
                />
            </div>
            <div className="flex items-center justify-end mt-6">
                <Button
                    type="button"
                    onClick={() => handleNextStep("advance_details", 'tab5', ['aadharNumber', 'panNumber', 'uanNumber', 'esicNumber', 'pfNumber', 'insuranceNumber', 'drivingLicenseNumber'])}
                >
                    {isLoading ? <Spinner /> : 'Save and Continue'}
                </Button>
            </div>
        </>
    )
}

export default OnboardAdvanceDetails
